import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { EventInfoWithConsentResponse, CoHostResponse, CoHostPublicControllerService } from '@ent-regis/entregis-ts-angular';
import { AttendancePreferenceEnum } from 'src/app/register-investor/models/register-investor.model';
import { checkEqualOtherName } from 'src/app/functions/form.function';

@Component({
  selector: 'app-investor-preference-section',
  templateUrl: './investor-preference-section.component.html',
  styleUrls: ['./investor-preference-section.component.scss']
})
export class InvestorPreferenceSectionComponent implements OnInit {

  @Input() preferenceForm!: FormGroup;
  @Input() eventInfoWithConsent: EventInfoWithConsentResponse;

  listInvited: CoHostResponse[] = [];
  attendanceEnum = AttendancePreferenceEnum;
  showInvitedBy = true;

  get f() { return this.preferenceForm.controls; }

  get isReady(): boolean {
    return !!this.preferenceForm && !!this.eventInfoWithConsent;
  }
  
  constructor(
    private coHostService: CoHostPublicControllerService,
  ) { }

  ngOnInit() {
    this.showInvitedBy = this.f.hasSalePerson.value !== false;

    if (!this.showInvitedBy) {
      this.f.coHostName.clearValidators();
      this.f.coHostName.updateValueAndValidity();
    }

    this.f.coHostName.valueChanges.subscribe(() => {
      this.updateBrokerNameValidation();
    });

    this.coHostService.getCoHostListUsingGET1(this.eventInfoWithConsent.eventId).subscribe((res) => {
      this.listInvited = res.data;
      this.updateBrokerNameValidation();
    });
  }

  ngOnChanges(): void {
    if (this.eventInfoWithConsent 
      && this.eventInfoWithConsent.isSubEvent 
      && !this.f.attendancePreference.value) {
      this.f.attendancePreference.setValue(this.attendanceEnum.PHYSICAL);
    }
  }

  checkSelectedCoHostIsOthers(): boolean {
    const selectedCoHost = this.listInvited.find((item) => item.name === this.f.coHostName.value);
    return !!selectedCoHost && checkEqualOtherName(selectedCoHost.name);
  }

  private updateBrokerNameValidation(): void {
    if (this.checkSelectedCoHostIsOthers()) {
      this.f.brokerName.setValidators(Validators.required);
    } else {
      this.f.brokerName.reset();
      this.f.brokerName.clearValidators();
    }

    this.f.brokerName.updateValueAndValidity();
  }

}
